import { observable, action, configure, runInAction, flow } from 'mobx';

import { User } from '@types/User.t';
import AuthApi from '@api/auth.api';

interface ISessionStore {
  currentUser: User,
  isLoading: boolean,
  erorrs: any
}

configure({ enforceActions: 'observed' });

class SessionStore implements ISessionStore {
  @observable currentUser: User = null;

  @observable isLoading = false;

  @observable errors: any = null;

  @observable isAdmin: any = null;

  @action.bound
  getCurrentUser () {
    return new Promise<void>(async (resolve, reject) => {
      this.isLoading = true;

      try {
        const user = await AuthApi.fetchCurrentUser();

        runInAction(() => {
          this.currentUser = user;
          this.isLoading = false;
          this.isAdmin = user.roles.includes('Admin');
        });
        resolve(this.isAdmin);
      } catch (error) {
        this.isLoading = true;

        runInAction(() => {
          this.errors = error;
          this.isLoading = false;
        });
        reject();
      }
    });
  }
}

export default new SessionStore();
